import * as _ from 'lodash';
import { FormatterEx } from 'slickgrid';
import { createElementText } from '../helpers';

function getvalue(data: object, value: string) {
  if (_.startsWith(value, '$rowdata')) {
    return _.get(data, value.split('.').slice(1).join('.'));
  }
  return value;
}

export interface LinkFormatterOptions {
  to?: string;
  params?: {
    [key: string]: string;
  };
  displayMember?: string;
  attrs?: object;
  href?: string;
  hrefField?: string;
  valueMember?: string;
  className?: string;
}

export function link<T>(opts: LinkFormatterOptions): FormatterEx<T> {
  if (!opts) {
    throw new TypeError('Options is required.');
  }

  if (!opts.href && !opts.hrefField) {
    throw new TypeError(
      'linkFormatter: Missing `href` or `hrefField` parameter.',
    );
  }

  const valueGetter = opts.displayMember
    ? (value: any, data: any) => _.get(data, opts.displayMember!)
    : (value: any) => value;

  const attrs: Dictionary<any> = { tabindex: 0, ...opts.attrs };

  const getHref = opts.href
    ? _.template(opts.href)
    : opts.hrefField
      ? (data: any) => data[opts.hrefField!]
      : null;

  if (opts.className) {
    attrs['class'] = opts.className;
  }

  if (opts.href === '#') {
    attrs['href'] = '#';
    attrs['onclick'] = 'return false;';
  }

  const linkFormatter: FormatterEx<T> = (row, cell, value, columnDef, data) => {
    if (value == null) {
      return '';
    }

    value = valueGetter(value, data);

    return createElementText(
      'a',
      {
        href: getHref ? getHref(data) : null,
        ...attrs,
        'data-value': value,
      },
      value,
    );
  };

  // const _getparams = (data: object) => _.reduce(opts.params, (m, v, k) => {
  //   m[k] = getvalue(data, v);
  //   return m;
  // }, { });

  // function linkFormatter(row, cell, value, columnDef, data) {
  //   if (value === null || _.isUndefined(value)) {
  //     return '';
  //   }

  //   const url = router.resolve({
  //     name: `app.${opts.to}`,
  //     params: _getparams(data)
  //   }).href;

  //   return `<a href="${url}">${value}</a>`;
  // };

  linkFormatter.exportRawData = true;

  return linkFormatter;
}
